import { render, staticRenderFns } from "./StatsCommercials.vue?vue&type=template&id=6c7a9fea&scoped=true"
import script from "./StatsCommercials.vue?vue&type=script&lang=js"
export * from "./StatsCommercials.vue?vue&type=script&lang=js"
import style0 from "./StatsCommercials.vue?vue&type=style&index=0&id=6c7a9fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a9fea",
  null
  
)

export default component.exports